import { Autocomplete, AutocompleteOption, Button, DialogContent, FormControl, FormLabel, Input, ListItemContent, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import React from "react";
import { toast,ToastContainer } from "react-toastify";

interface DialogFormProps {
    contactpersons: any[];
    accountTypes: any[];
    accounts: any[];
    memberTypes: any[];
    onSave: (data: any) => void;
}


export default function DialogForm({ memberTypes,contactpersons, accountTypes, accounts, onSave }: DialogFormProps) {


    const [open, setOpen] = React.useState<boolean>(false);
    const [isNewContact, setIsNewContact] = React.useState<boolean>(false);
    const [isNewAccount, setIsNewAccounts] = React.useState<boolean>(false);
    const [selectedItems, setSelectedItems] = React.useState<Record<string, any | null>>({});

    const filteredContacts = selectedItems["account"]
    ? contactpersons.filter(contact => contact.account && contact.account.id === selectedItems["account"].id)
    : contactpersons;
  
  const filteredAccounts = selectedItems["contact"]
    ? (selectedItems["contact"].account 
        ? accounts.filter(account => account.id === selectedItems["contact"].account.id)
        : [])
    : accounts;
    
    function toggleIsNewContact(): void {
        setIsNewContact(!isNewContact);
        if(isNewContact){
            setSelectedItems((prevItems) => ({ ...prevItems, ["contact"]: null }));
        }
        else(
            setSelectedItems((prevItems) => ({ ...prevItems, ["firstname"]: "", ["lastname"]: "", ["email"]: "" }))
        )
      }

    function toggleIsNewAccount(): void {
        setIsNewAccounts(!isNewAccount);
        if(isNewAccount){
            setSelectedItems((prevItems) => ({ ...prevItems, ["account"]: null }));
        }
        else(
            setSelectedItems((prevItems) => ({ ...prevItems, ["tradename"]: "", ["officialname"]: "", ["vatnumber"]: "", ["accountType"]: "" }))
        )
    }

    const handleInputChange = (name: string, value: any | null) => {
        const formattedlabel = name.replace(/\s/g, '');
        setSelectedItems((prevItems) => ({ ...prevItems, [formattedlabel]: value }));
    };


    const handleSubmit = () => {
      if(validateForm()){
        onSave(selectedItems);
        setSelectedItems((prevItems) => ({ ...prevItems, ["contact"]: null, ["firstname"]: null, ["lastname"]: null, ["email"]: null, ["account"]: null, ["tradename"]: null, ["officialname"]: null, ["vatnumber"]: null, ["accountType"]: null }))
        setIsNewAccounts(false);
        setIsNewContact(false);
      }
    };
    const validateForm = () => {
        if (isNewContact) {
            if (!selectedItems.firstname || !selectedItems.lastname || !selectedItems.email) {
                toast.error("Please fill in all the required fields");
                return false;
            }
        }
        else if(!selectedItems.contact)
        {
            toast.error("Please select a contact");
            return false;
        }

        if (isNewAccount) {
            if (!selectedItems.tradename || !selectedItems.officialname || !selectedItems.vatnumber || !selectedItems.accountType) {
                toast.error("Please fill in all the required fields");
                return false;
            }
        }
        else if(!selectedItems.account)
        {
            toast.error("Please select an account");
            return false;
        }

        return true;
      }

    return (
        <React.Fragment>
            <Button
                id="addButton"
                variant="outlined"
                color="neutral"
                onClick={() => setOpen(true)}
            >
                Partner toevoegen
            </Button>
            <Modal open={open} onClose={() => setOpen(false)}>
                <React.Fragment>
                    <ModalDialog>
                        <DialogContent>
                            Vul de nodige info in om een partner toe te voegen
                        </DialogContent>
                        <form
                            onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                                event.preventDefault();
                                setOpen(false);
                            }}
                        >
                            <Stack spacing={2}>
                            <FormControl>
                  <div className="newContact" >
                    <FormLabel>Contact Persoon</FormLabel>
                    <Button onClick={() => toggleIsNewContact()} sx={{ backgroundColor: "#484494" }}> {isNewContact ? "Bestaand Contact" : "Nieuw Contact"} </Button>
                  </div>
                  <div className={isNewContact ? "hidden" : "show"}>
                    <Autocomplete
                      value={(selectedItems["contact"] as any || null)}
                      sx={{ width: 600 }}
                      getOptionLabel={(option) => (option.firstName + " " + option.lastName)}
                      loading={contactpersons.length === 0}
                      options={filteredContacts}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      noOptionsText="Geen contact gevonden"
                      onChange={(event, value) => handleInputChange("contact", value)}
                      renderOption={(props, option) => (
                        <AutocompleteOption {...props} key={option.id}>
                          <ListItemContent sx={{ fontSize: "sm" }}>
                            {(option.firstName + " " + option.lastName)}
                            <Typography level="body-xs">
                              {option.email ? option.email : "Geen email beschikbaar"}
                            </Typography>
                          </ListItemContent>
                        </AutocompleteOption>
                      )}
                    />
                  </div>
                </FormControl>
                <div className={isNewContact ? "show" : "hidden"}>
                  <FormControl>
                    <FormLabel>Voornaam</FormLabel>
                    <Input
                      value={selectedItems["firstname"] || ""}
                      onChange={(event) => handleInputChange("firstname", event.target.value)}
                      sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Achternaam</FormLabel>
                    <Input
                      value={selectedItems["lastname"] || ""}
                      onChange={(event) => handleInputChange("lastname", event.target.value)}
                      sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                      required
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Email</FormLabel>
                    <Input
                      value={selectedItems["email"] || ""}
                      onChange={(event) => handleInputChange("email", event.target.value)}
                      sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                      required
                    />
                  </FormControl>
                  </div>
                  <FormControl>
                    <div className="newContact" >
                      <FormLabel>Account Naam</FormLabel>
                      <Button onClick={() => toggleIsNewAccount()} sx={{ backgroundColor: "#484494" }}> {isNewAccount ? "Bestaand Account" : "Nieuw Account"} </Button>
                    </div>

                    <div className={isNewAccount ? "hidden" : "show"}>
                      <Autocomplete
                        value={(selectedItems["account"] as any || null)}
                        sx={{ width: 600 }}
                        getOptionLabel={(option) => option.tradeName}
                        loading={accounts?.length === 0}
                        options={filteredAccounts}
                        noOptionsText="Geen account gevonden"
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        onChange={(event, value) => handleInputChange("account", value)}
                        renderOption={(props, option) => (
                          <AutocompleteOption {...props} key={option.id}>
                            <ListItemContent sx={{ fontSize: "sm" }}>
                              {option.tradeName}
                              <Typography level="body-xs">
                                {option.vatNumber ? option.vatNumber : "Geen BTW nummer beschikbaar"}
                              </Typography>
                            </ListItemContent>
                          </AutocompleteOption>
                        )}
                      />
                    </div>
                    <div className={isNewAccount ? "show" : "hidden"}>
                      <FormControl>
                        <FormLabel>Account Naam</FormLabel>
                        <Input
                          value={selectedItems["tradename"] || ""}
                          onChange={(event) => handleInputChange("tradename", event.target.value)}
                          sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                          required
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Officiele Naam</FormLabel>
                        <Input
                          value={selectedItems["officialname"] || ""}
                          onChange={(event) => handleInputChange("officialname", event.target.value)}
                          sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                          required
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>BTW Nummer</FormLabel>
                        <Input
                          value={selectedItems["vatnumber"] || ""}
                          onChange={(event) => handleInputChange("vatnumber", event.target.value)}
                          sx={{ "--Input-focusedHighlight": "#b6b4d4" }}
                          required
                        />
                      </FormControl>
                      <FormControl>
                        <FormLabel>Account Type</FormLabel>
                        <Autocomplete
                          required
                          value={(selectedItems["accountType"] as any || null)}
                          sx={{ width: 600 }}
                          getOptionLabel={(option) => option.name}
                          loading={accountTypes.length === 0}
                          options={accountTypes}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          onChange={(event, value) => handleInputChange("accountType", value)}
                          
                          renderOption={(props, option) => (
                            <AutocompleteOption {...props} key={option.id}>
                              <ListItemContent sx={{ fontSize: "sm" }}>
                                {option.name}
                              </ListItemContent>
                            </AutocompleteOption>
                          )}
                        />
                      </FormControl>
                    </div>
                  </FormControl>
                             
                                <Button id="addButton"
                                    variant="outlined"
                                    color="neutral" sx={{ backgroundColor: "#484494" }} type="submit" onClick={() => handleSubmit()}>
                                    Aanvraag versturen
                                </Button>
                            </Stack>
                        </form>
                    </ModalDialog>
                    <ToastContainer />
                </React.Fragment>
            </Modal>

        </React.Fragment>
    );

}